/**
 * Marbenio Quiet Luxury — in-page smooth scroll for key homepage anchors.
 * Cubic ease-in-out with sticky-header offset; respects reduced motion.
 */
(function () {
  if (window.__qlSmoothScrollInit) return;
  window.__qlSmoothScrollInit = true;

  var ALIASES = {
    'section-curated-ensembles': 'section-curated-ensembles',
    'homepage-ensembles': 'section-curated-ensembles',
    'homepage-basics': 'homepage-basics',
    'section-atelier-teaser': 'section-atelier-teaser',
    'homepage-outerwear': 'homepage-outerwear'
  };
  var MIN_MS = 720;
  var MAX_MS = 980;
  var BREATHING_ROOM = 18;

  var rafId = null;
  var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return reducedQuery.matches;
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function getHeaderOffset() {
    var header =
      document.querySelector('sticky-header') ||
      document.querySelector('.section-header') ||
      document.getElementById('shopify-section-header');
    if (!header) return 72 + BREATHING_ROOM;
    return Math.ceil(header.getBoundingClientRect().height) + BREATHING_ROOM;
  }

  function targetY(el) {
    var top = el.getBoundingClientRect().top + window.pageYOffset;
    return Math.max(0, top - getHeaderOffset());
  }

  function cancelScroll() {
    if (rafId != null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  }

  function bindInterrupt() {
    var opts = { passive: true, once: true };
    window.addEventListener('wheel', cancelScroll, opts);
    window.addEventListener('touchstart', cancelScroll, opts);
    window.addEventListener('keydown', cancelScroll, opts);
  }

  function scrollToTarget(el, hash, updateHash) {
    if (!el) return;

    var end = targetY(el);

    if (prefersReducedMotion()) {
      window.scrollTo(0, end);
      if (updateHash && location.hash !== hash) {
        history.pushState(null, '', hash);
      }
      el.classList.add('is-revealed');
      return;
    }

    cancelScroll();
    var start = window.pageYOffset;
    var distance = end - start;
    if (Math.abs(distance) < 2) {
      el.classList.add('is-revealed');
      return;
    }

    var duration = Math.min(MAX_MS, Math.max(MIN_MS, Math.abs(distance) * 0.42));
    var t0 = performance.now();
    bindInterrupt();

    function frame(now) {
      var t = Math.min(1, (now - t0) / duration);
      window.scrollTo(0, start + distance * easeInOutCubic(t));
      if (t < 1) {
        rafId = requestAnimationFrame(frame);
      } else {
        rafId = null;
        if (updateHash && location.hash !== hash) {
          history.pushState(null, '', hash);
        }
        el.classList.add('is-revealed');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
        try {
          el.focus({ preventScroll: true });
        } catch (e) {
          /* ignore */
        }
      }
    }

    rafId = requestAnimationFrame(frame);
  }

  function resolveHash(rawHash) {
    if (!rawHash) return null;
    var id = rawHash.charAt(0) === '#' ? rawHash.slice(1) : rawHash;
    var resolved = ALIASES[id];
    if (!resolved) return null;
    return { id: resolved, hash: '#' + resolved };
  }

  function samePageTarget(anchor) {
    var raw = anchor.getAttribute('href');
    if (!raw) return null;
    if (raw.charAt(0) === '#') {
      return resolveHash(raw);
    }
    try {
      var url = new URL(raw, window.location.href);
      if (url.origin !== window.location.origin) return null;
      var resolved = resolveHash(url.hash);
      if (!resolved) return null;
      var here = window.location.pathname.replace(/\/$/, '') || '/';
      var there = url.pathname.replace(/\/$/, '') || '/';
      if (here !== there) return null;
      return resolved;
    } catch (e) {
      return null;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented) return;
      if (event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var anchor = event.target.closest('a[href]');
      if (!anchor || anchor.target === '_blank') return;
      var target = samePageTarget(anchor);
      if (!target) return;

      var el = document.getElementById(target.id);
      if (!el) return;

      event.preventDefault();
      scrollToTarget(el, target.hash, true);
    },
    false
  );

  function initReveal() {
    var el = document.getElementById('section-curated-ensembles');
    if (!el) return;

    if (prefersReducedMotion()) {
      el.classList.add('is-revealed');
      return;
    }

    el.classList.add('ql-ensembles--revealable');

    if (typeof IntersectionObserver === 'undefined') {
      el.classList.add('is-revealed');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -6% 0px' }
    );
    io.observe(el);
  }

  function handleInitialHash() {
    var resolved = resolveHash(window.location.hash);
    if (!resolved) return;
    var el = document.getElementById(resolved.id);
    if (!el) return;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrollToTarget(el, resolved.hash, false);
      });
    });
  }

  function boot() {
    initReveal();
    handleInitialHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
